import { gql } from "@apollo/client";

export const GET_COURSES = gql`
  query GetCoursesResolver {
    getCoursesResolver {
      name
      description
      createdAt
      category
      _id
      duration
      status
      headquarterIds
      turnsConformation {
        enrollmentCount
        _id
        name
        status
        cost {
          amountOfFees
          inscription
          total
        }
        startDate
        finishDate
        permanentEnrollment
        schedule {
          day
          startTime
          endTime
          classroomId
        }
      }
    }
  }
`;

export const GET_COURSE_CONFORMATION = gql`
  query getCourseConformationResolver($courseId: String) {
    getCourseConformationResolver(courseId: $courseId) {
      _id
      name
      cost {
        amountOfFees
        inscription
        total
      }
      startDate
      finishDate
      schedule {
        startTime
        endTime
        day
        classroomId
      }
      conformation {
        students {
          _id
          fullName
          dni
          email
          gender
          birthDay
          medicalRecord
          status
          nationality
          createdAt
          phoneNumbers {
            phoneNumber
          }
          addressInfo {
            street
            cp
            city
          }
        }
        instructor {
          _id
          fullName
          dni
        }
      }
    }
  }
`;

export const GET_COURSES_BY_STUDENT_ID = gql`
  query GetCoursesByStudentIdResolver($studentId: String) {
    getCoursesByStudentIdResolver(studentId: $studentId) {
      _id
      courseInfo {
        _id
        name
        description
        category
        duration
        createdAt
        status
      }
      turnInfo {
        _id
        name
        cost {
          amountOfFees
          inscription
          total
        }
        startDate
        finishDate
        permanentEnrollment
        schedule {
          day
          startTime
          endTime
          classroomId
        }
      }
    }
  }
`;
